"use strict";
import { Fragment } from "react";
import { DropdownMenuSheetItem, Flex, Separator, isWeb } from "ui/src";
export function MenuContent({ items, handleCloseMenu }) {
  return <Flex
    asChild
    flexDirection="column"
    gap="$spacing4"
    p="$spacing8"
    backgroundColor="$surface1"
    borderRadius="$rounded20"
    borderWidth="$spacing1"
    borderColor="$surface3"
    minWidth={200}
  >
      {
    /* eslint-disable-next-line react/forbid-elements */
  }
      <div
    onContextMenu={(e) => {
      e.preventDefault();
      e.stopPropagation();
    }}
  >
        {items.map(({ label, onPress, Icon, showDivider, disabled, iconColor, closeDelay }, index) => <Fragment key={index}>
            {showDivider && <Separator my="$spacing6" />}
            <DropdownMenuSheetItem
    variant={isWeb ? "small" : "medium"}
    label={label}
    icon={Icon && <Icon size="$icon.16" color={iconColor ?? "$neutral2"} />}
    disabled={disabled}
    closeDelay={closeDelay}
    handleCloseMenu={handleCloseMenu}
    onPress={onPress}
  />
          </Fragment>)}
      </div>
    </Flex>;
}
